import { defineQuery } from 'next-sanity'
import { imageFields } from '../atoms'

export const careersBenefitsBlockFields = `
  _id,
  _type,
  introText,
  introImage {
    ${imageFields}
  },
  workingHours[]{
    icon {
      ${imageFields}
    },
    mainContent
  }
`

export const CAREERS_BENEFITS_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-benefits-block"][0]{
    ${careersBenefitsBlockFields}
  }
`)
